import { CSSObject, styled } from '../theming';
import merge from 'lodash/merge';
import { LayoutProps } from './types';
import responsiveProp, { CSSValue, ResponsiveProp } from '../utils/responsiveProp';

const ALIGN_TO_JUSTIFY = {
  leading: 'flex-start',
  center: 'center',
  trailing: 'flex-end',
  stretch: 'stretch',
  spaceBetween: 'space-between',
};

const valueToFlexDirection = (
  direction: ResponsiveProp<'stack' | 'stackReverse' | 'inlineReverse' | 'inline'>
) => {
  switch (direction) {
    case 'stack':
      return 'column';
    case 'stackReverse':
      return 'column-reverse';
    case 'inline':
      return 'row';
    case 'inlineReverse':
      return 'row-reverse';
    default:
      return 'row';
  }
};

export const getPadding = (padding: CSSValue): string => {
  if (typeof padding === 'string') return padding;
  if (typeof padding === 'number') return `${padding}px`;
  return padding.map((pd) => getPadding(pd)).join(' ');
};

export const StyledLayout = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['direction', 'wrap', 'gap'].includes(prop) && defaultValidatorFn(prop),
})<LayoutProps>(
  ({ wrap, gap, padding, align, alignItems, direction }): CSSObject => ({
    display: 'flex',
    ...merge(
      responsiveProp(wrap, (wrap) => ({ flexWrap: wrap ? 'wrap' : 'nowrap' })),
      responsiveProp(align, (align) => ({ justifyContent: ALIGN_TO_JUSTIFY[align] })),
      responsiveProp(alignItems, (alignItems) => ({ alignItems: ALIGN_TO_JUSTIFY[alignItems] })),
      responsiveProp(padding, (padding) => ({
        padding: getPadding(padding),
      })),
      responsiveProp(direction, (direction) => ({
        flexDirection: valueToFlexDirection(direction),
      })),
      responsiveProp(gap, 'gap')
    ),
  })
);
